export enum EConfigFlag {
	PlatformReady = "platformReady",
	ConfigReady = "configReady",
	StaticConfigReady = "staticConfigReady"
}